import { defineComponent, openBlock, createElementBlock, renderSlot, createElementVNode, toDisplayString } from 'vue';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "list-wrapper",
  props: {
    title: { default: "" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", { class: "se-list-wrapper" }, [
        renderSlot(_ctx.$slots, "header", { title: __props.title }, () => [
          createElementVNode("header", { class: "se-list-wrapper-header" }, [
            createElementVNode("h1", { class: "se-list-wrapper-header-title" }, toDisplayString(__props.title), 1)
          ])
        ], true),
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=list-wrapper.vue.js.map
